import type { WallShape } from '@walls/store';
import { getShapeType } from '../utils/shapeAttributes';
import { drawCircle } from './drawCircle';
import { drawLine } from './drawLine';
import { drawRectangle } from './drawRectangle';
import { drawText } from './drawText';

export function drawShape(
  context: CanvasRenderingContext2D,
  shape: WallShape,
  zoom: number,
  selected: boolean,
  editable = selected
) {
  switch (getShapeType(shape)) {
    case 'circle':
      drawCircle(context, shape, zoom, selected);
      break;
    case 'line':
      drawLine(context, shape, selected, editable);
      break;
    case 'text':
      drawText(context, shape, zoom, selected);
      break;
    case 'rectangle':
    default:
      drawRectangle(context, shape, zoom, selected);
      break;
  }
}
